export const IS_DEV_MODE = process.env.NODE_ENV === 'development';
